import { SuspensePage } from '@/shared/ui/layout/SuspensePage';
import { PagesSupportStaffCreateMain } from './modules/ui/Main';

const SupportStaffCreatePage = (
  <SuspensePage>
    <PagesSupportStaffCreateMain />
  </SuspensePage>
);

export default SupportStaffCreatePage;
